import ApiClient from '@lib/apiClient';

import { printApiError } from '@utils/Util';

export const fetchBrandWithSubBrand = async (queryParams) => {
	const { data } = await ApiClient.GET('getBrandWithSubBrand', queryParams);
	return data;
};

export const placeOrder = async (requestBody) => {
	try {
		const { data } = await ApiClient.POST('order', requestBody);
		return data;
	} catch (error) {
		printApiError(error);
		return null;
	}
};
